import * as React from "react";
import { theme } from "../../../theme";

interface Props {
  color?: string;
}

export const CopyPersonIcon: React.FC<Props> = ({
  color = theme.colors.text,
}) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M5 9.66667C5 7.4668 5 6.36683 5.68342 5.68342C6.36683 5 7.4668 5 9.66667 5C11.8665 5 12.9665 5 13.6499 5.68342C14.3333 6.36683 14.3333 7.4668 14.3333 9.66667C14.3333 11.8665 14.3333 12.9665 13.6499 13.6499C12.9665 14.3333 11.8665 14.3333 9.66667 14.3333C7.4668 14.3333 6.36683 14.3333 5.68342 13.6499C5 12.9665 5 11.8665 5 9.66667Z"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5.00002 11C4.06905 11 3.60357 11 3.22937 10.869C2.55913 10.6345 2.03215 10.1075 1.79763 9.43729C1.66669 9.06309 1.66669 8.59756 1.66669 7.66663V6.33329C1.66669 4.13341 1.66669 3.03346 2.35011 2.35005C3.03352 1.66663 4.13347 1.66663 6.33335 1.66663H7.66669C8.59762 1.66663 9.06315 1.66663 9.43735 1.79757C10.1076 2.03209 10.6346 2.55907 10.8691 3.22931C11 3.60351 11 4.06899 11 4.99996"
      stroke={color}
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.45753 11.9507C6.88114 12.3017 5.36989 13.0185 6.29035 13.9153C6.73998 14.3534 7.24075 14.6667 7.87035 14.6667H11.463C12.0926 14.6667 12.5933 14.3534 13.043 13.9153C13.9635 13.0185 12.4522 12.3017 11.8758 11.9507C10.5242 11.1276 8.80913 11.1276 7.45753 11.9507Z"
      stroke={color}
      strokeWidth="0.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M11 8.5C11 9.32842 10.3284 10 9.5 10C8.67158 10 8 9.32842 8 8.5C8 7.67157 8.67158 7 9.5 7C10.3284 7 11 7.67157 11 8.5Z"
      stroke={color}
      strokeWidth="0.8"
    />
  </svg>
);
